export const onPopstateReload = () => {
  window.onpopstate = history.onpushstate = (e) => {
    location.reload()
  }
}

export const setHistory = (params = {}, pathname) => {
  let location = window.location
  if (pathname) {
    let origin = window.location.origin
    if (origin.endsWith('/')) {
      origin = origin.slice(0, -1)
    }
    location = origin + pathname
  }
  const url = new URL(location)
  let deleteKeys = []
  for (const key of url.searchParams.keys()) {
    if (!params[key]) {
      deleteKeys.push(key)
    }
  }
  for (let key of Object.keys(params)) url.searchParams.set(key, params[key])
  for (let key of deleteKeys) url.searchParams.delete(key)
  history.pushState({}, document.title, url)
}

export const onHistoryChange = (cb) => {
  if (typeof window !== 'undefined') {
    window.addEventListener('popstate', cb)
  }
}
